import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';

import { CheckAmbulanciaService } from '../services/check-ambulancia.service';
import { VeiculoService } from '../services/veiculo.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ExcelService } from '../services/excel.service';
import { AuthService } from '../services/auth.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { ProfissionalService } from '../services/profissional.service';
import { EspecialidadeVeiculoService } from '../services/especialidade-veiculo.service';


@Component({
  selector: 'app-relatorio-checklist-ambulancia',
  templateUrl: './relatorio-checklist-ambulancia.component.html',
  styleUrls: ['./relatorio-checklist-ambulancia.component.css'],
	animations: [loadingFade, modal, alert]
})
export class RelatorioChecklistAmbulanciaComponent implements OnInit {
  public loading = false;
	public checklists = [];
	public veiculos = [];
	public unidades = [];
	public clientes = [];
	public tipoVeiculo = [];
	public profissionais = [];
	public periodos = [{ periodo: 'D', periodo_nome: 'Diurno'}, { periodo: 'N', periodo_nome: 'Noturno'}];
	public situacoes = [{ situacao: '1', situacao_nome: 'Ativo'}, { situacao: '0', situacao_nome: 'Inativo'}];
	public perfil = this.authSvc.getPerfil();

	public formFiltro: FormGroup;

	public active = false;

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// modal
	public modalApagar = 'hidden';
	public idChecklistApagar = null;

	// alert
	public msg_alerta = '';
	public class_alerta = '';
	public flag_alerta = 'hidden';

	constructor(private fb: FormBuilder,
				private checkAmbulanciaSvc: CheckAmbulanciaService,
				private clienteSvc: ClienteService,
				private unidadeSvc: UnidadeService,
				private veiculoSvc: VeiculoService,
				private authSvc: AuthService,
				private profissionalSvc: ProfissionalService, 
				private especialidadeVeiculoSvc: EspecialidadeVeiculoService,
				private excelSvc: ExcelService) { }

	ngOnInit() {
		this.criaFiltro();
	}
	
	criaFiltro() {
		this.pegaClientes();
		this.pegaUnidades();
		this.pegaVeiculos();
		this.pegaEspecialidadesVeiculo();
		
		this.formFiltro = this.fb.group({
			cliente_id:null,
			unidade_id:null,
			veiculo_id:null,
			check_ambulancia_turno:null,
			data_inicio: null,
			data_fim: null,
			obs:false,
			usuario: this.authSvc.getUsuarioId(),
			especialidade_veiculo_id___veiculo: null,
			profissional_id___profissional: null
		});

		let campos_data = ['data_inicio', 'data_fim'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formFiltro.controls[campo].setValue(formatted);
				}
			});
		}
	}

	pegaChecklists() {
		this.checklists = [];
		this.loading = true;
		this.checkAmbulanciaSvc.relatorio(this.formFiltro.value).then((data: any) => {
			this.checklists = data;
			this.count = this.checklists.length;
			if(this.count == 0){
				Swal.fire({
					title: 'Erro',
					text: 'Não foi possível encontrar nenhum checklist, verifique a pesquisa e tente novamente.',
					type: 'error'
				});
			}
			this.loading = false;
		}).catch((err) => {
			this.loading = false;
		});
	}

	pegaClientes(){
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.clientes = data;
		});
	}

	pegaUnidades(){
		this.unidadeSvc.getUnidadesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	onChangeCliente(evento){
		this.formFiltro.controls.unidade_id.setValue(null);
		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaVeiculos(){
		this.veiculoSvc.getAmbulancias(this.authSvc.getUsuarioId()).then((data: any) =>{
			this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	exportarExcel(){
		this.pegaChecklists();
		let checklists = [];
		this.checkAmbulanciaSvc.relatorioExcel(this.formFiltro.value).then((data: any) => {
			checklists = data;
			if(checklists.length > 0){
				this.excelSvc.exportAsExcelFile(checklists, 'Chronos Frota - Checklists');
			}
		}).catch((err) => {
			Swal.fire({
				type: 'error',
				title: 'Não foi possível gerar excel!'
			});
		});
	}

	print(id){
		let url = location.href.split('#')[0] + '#' +'(print:print/checkambulancia/'+ id +')'
		window.open(url);
	}

	calculaTempoExecucao(inicio, fim){
		if(inicio != null && fim != null){
			inicio = moment(inicio, 'YYYY-MM-DD HH:mm:ss')
			fim = moment(fim, 'YYYY-MM-DD HH:mm:ss')
			let tempo = moment.duration(fim.diff(inicio));
			return  tempo.minutes() + ' m ' + tempo.seconds() + ' s';
		}
		else{
			return null;
		}
		
	}

	deletado(flag){
		return flag == 'S' ? 'deletado' : '';
	}

	onChangeObs(){
		this.active = this.active == true ? false : true;
	}


	pegaEspecialidadesVeiculo() {
		this.especialidadeVeiculoSvc.getEspecialidadesVeiculoIn('ambulancia','especialidade_veiculo_nome').then((data: any[]) => {
			this.tipoVeiculo = data;
		}).catch((err) => {
			console.log(err);
		});
	}



	onChangeVeiculoUnidade(e){

		if(typeof e === 'undefined'){
			return "";
		}else{
		this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoUnidadeEspecialidade(e.unidade_id,"ambulancia").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: e.unidade_id,
				cliente_id: e.cliente_id
			  });
			}
	
			this.veiculos = dados;
			this.pegaProfissionaisClienteUnidade(e)
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });
		}
	}

	pegaProfissionaisClienteUnidade(e){
		this.loading = true;
		
		this.profissionalSvc.getProfissionalEdit(e.cliente_id,e.unidade_id).then((data: any[]) => {
				this.profissionais = data;
	
		  this.loading = false;
			}).catch((err) => {
				console.log(err);
			});
	  }		

	  onClickLimparCampos(){
		this.pegaClientes();
		this.pegaUnidades();
		this.pegaVeiculos();
		this.pegaEspecialidadesVeiculo();
		
		this.formFiltro = this.fb.group({
			cliente_id:null,
			unidade_id:null,
			veiculo_id:null,
			check_ambulancia_turno:null,
			data_inicio: null,
			data_fim: null,
			obs:false,
			usuario: this.authSvc.getUsuarioId(),
			especialidade_veiculo_id___veiculo: null,
			profissional_id___profissional: null
		});

	  }

}
